<mat-card appearance="outlined" class="p-0"
  fxflex>
  <mat-card-title class="tab-card-title m-0 d-flex justify-content-start align-items-center">
    <h3 class="m-0">{{title}}</h3>
  </mat-card-title>
  <mat-divider></mat-divider>
  <mat-card-content>
    <mat-tab-group dynamicHeight>
      <!-- CURRENT  -->
      <mat-tab [label]="'addresses.current' | translate">
        <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
        @if (!loading) {
          <ng-content
          select="[tab1]"></ng-content>
        } @else {
          <div class="loading-spinner">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
        }
      </mat-tab>
      <!-- HISTORY  -->
      <mat-tab [label]="'addresses.future' | translate">
        <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
        <div class="history">
          @if (!loading) {
            <ng-content
            select="[tab2]"></ng-content>
          } @else {
            <div class="loading-spinner">
              <mat-spinner diameter="30"></mat-spinner>
            </div>
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>

<ng-template #actionButtons>
  @if (showHistoryActions) {
    <div
      class="actions d-flex justify-content-end">
      <button mat-icon-button
        class="addButton"
        [title]="addTitle | translate"
        (click)="addHistoryClicked()">
        <mat-icon>{{ addIcon }}</mat-icon>
      </button>
    </div>
  }
</ng-template>

